import { get } from "./utils";
import { Labels } from "../models/statuspage/labels";

export const getTranslations = async () =>
  await get<Labels>("translations");
